import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import CodeInput from 'react-otp-input';
import { doResetParentalCode,setParentalCodeStep,saveToHistory,toggleDisplayPopUp,getPinParentalCodeAsync } from '../../Block/TvActivationCodeRecoveryBlock/TvActivationCodeRecoveryBlockSlice';
import {Step} from './ResetParentalCodeEnum';
import {parentalControlReport} from './ParentalControlReports';
import Popup from "app/Components/Shared/Popup/PopUp";
import { buildUrlAndOpenSameWindow } from '../../../utilities/StringHelpers/StringHelpers';
import {InfoPopUp} from "app/Components/Block/TvResetParentalCodeBlock/InfoPopUp";
import Config from '../../../Config';

const ResetCode = (props) => {

    useEffect(() => {
        //console.info('ResetCode - props', props);
        props.saveToHistory('reset-code');
        props.getPinParentalCodeAsync();
    }, []);

    const [code, setCode] = useState(props.pinParentalCode);
    const [newCode, setNewCode] = useState('');
    const [codeValidationError, setCodeValidationError] = useState('');
    const [inputType, setInputType] = useState('password');
    const [isDisplayChangeCodePopup, setIsDisplayChangeCodePopup] = useState(false);
    const [changeCodePopupStatus, setChangeCodePopupStatus] = useState('');

    //const [codeError, setCodeError] = useState(null);
    // const title = 'קוד אישור';
    // const text1 = 'שכחתם את הקוד?';
    // const text2 = 'זה המקום להגדיר את הקוד החדש שלכם<br/>הקוד צריך להיות מורכב מספרות בלבד';
    //const txtError = 'אנא וודאו שהשלמתם את כל השדות';

    useEffect(() => {
        setCode(props.pinParentalCode);
    }, [props.pinParentalCode]);

    // const handleClick = () => {
    //     if (code.length == 4) {
    //         let req = {
    //             externalAssetId: props.tvAccount?.currentParrentalCodeAccount?.assetExternalId,
    //             pinCode: code,
    //         }
    //         props.doResetParentalCode(req);
    //     }
    //     parentalControlReport('New Parental Code Page', 'Ongoing', 'New Parental Code Page Button Clicked', props.account?.username, props.userData?.firstName + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '', props.contactNumber, props.ban);
    // }

    useEffect(() => {
        parentalControlReport('New Parental Code Page', 'Ongoing', 'New Parental Code Page Displayed', props.account?.username, props.userData?.firstName + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '', props.contactNumber, props.tvAccount?.currentParrentalCodeAccount?.ban);
        props.toggleDisplayPopUp();
    }, []);

    // useEffect(() => {
    //     if (props.tvAccount.resetParentalCodeReady)
    //         props.setParentalCodeStep(Step.COMPLETED_PAGE)
    // }, [props.tvAccount.resetParentalCodeReady]);

    // const handleCode = (code) => {
    //     setCode(code);
    //     if (code.length == 4 || code.length == 0) {
    //         setCodeError(null);
    //     } else if (code.length > 0 && code.length < 4) {
    //         setCodeError(true);
    //     }
    // }

    return (
        <div className='reset-code'>
            <div style={{textAlign: "center"}}>
                <div className='title-info'>בקרת הורים</div>
                <Image src={require('./images/logo-reset.svg')} alt='logo-reset-icon' />
            </div>
            <div className='text-1'>הקוד שלכם</div>
            {/* <div className='text-2' dangerouslySetInnerHTML={{__html: text2}}></div> */}

            <div className='code-area'>
                <CodeInput
                    shouldAutoFocus={true}
                    value={inputType == 'password' ? '****' : code}
                    //onChange={handleCode}
                    numInputs={4}
                    isInputNum={true}
                    //separator={<span className='inputSeparator'></span>}
                    containerStyle={`otp-code-view-wrapper`}
                    inputStyle={`input-design`}
                    renderInput={(inputProps, index) => (
                        <input {...inputProps} key={index} type='text' disabled={true} autoComplete="one-time-code" style={inputType == 'password' ? {paddingTop:'10px'} : null} />
                    )}
                />
            </div>

            <div className='small-button-wrapper'>
                <BtnSubmit text={inputType == 'password' ? 'לצפייה בקוד' : 'סגירה'} onclick={handleInputTypeClick} className={inputType == 'password' ? 'icon-on' : 'icon-off'} />
            </div>

            <div className='change-code-wrapper'>
                <a href='#' onClick={(e)=> handleOnChangeCode(e)}>לשינוי הקוד</a>
            </div>

            <div className='button-wrapper'>
                <BtnSubmit className='btn-submit-white' text={'לאזור האישי'} onclick={handleGoToLobby} />
            </div>


            <Popup showPopUp={props.tvAccount.displayPopUp} onClose={() => props.toggleDisplayPopUp()}>
                <InfoPopUp onclick={() => props.toggleDisplayPopUp()}/>
            </Popup>

            <Popup showPopUp={isDisplayChangeCodePopup} onClose={() => setIsDisplayChangeCodePopup(false)}>
                { renderChangeCodePopup() }
            </Popup>

        </div>
    );

    function handleInputTypeClick() {
        setInputType(inputType == 'password' ? 'text' : 'password');
    }

    function handleGoToLobby() {
        buildUrlAndOpenSameWindow(Config.lobbyUrl);
    }

    function handleOnChangeCode(e) {
        e.preventDefault();
        setChangeCodePopupStatus('');
        setIsDisplayChangeCodePopup(true);
    }

    function renderChangeCodePopup() {
        switch (changeCodePopupStatus) {
            case '':
                return(
                    <div className='popup-change-code'>
                        <div className='popup-title'> בקרת הורים </div>
                        <div className='popup-icon'></div>
                        <div className='popup-text-bold'> יש להזין את הקוד החדש שלכם </div>
                        <div className='popup-text'> הקוד צריך להיות מורכב מספרות בלבד </div>
                        <div className='popup-code-wrapper'>
                            <CodeInput
                                shouldAutoFocus={true}
                                value={newCode}
                                onChange={handleCode}
                                numInputs={4}
                                isInputNum={true}
                                //separator={<span className='inputSeparator'></span>}
                                containerStyle={`otp-code-edit-wrapper`}
                                inputStyle={`input-design`}
                                renderInput={(inputProps, index) => (
                                    <input {...inputProps} key={index} type='number' autoComplete="one-time-code" />
                                )}
                            />
                            {
                                codeValidationError &&
                                <div className='error-code-area'>{codeValidationError}</div>
                            }
                        </div>
                        <div className='popup-button-wrapper'>
                            <BtnSubmit text='אישור' onclick={handleChangeCodeClick} />
                        </div>
                    </div>
                )
            case 'success':
                return(
                    <div className='popup-change-code'>
                        <div className='popup-success-icon'></div>
                        <div className='popup-success-title'> הקוד החדש נשמר בהצלחה! </div>
                        <div className='popup-button-wrapper'>
                            <BtnSubmit text='סיום' onclick={handleChangeCodeFinishClick} />
                        </div>
                    </div>
                    )
            case 'error':
                return(
                    <div className='popup-change-code'>
                        <div className='popup-error-icon'></div>
                        <div className='popup-error-title'> מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת </div>
                        <div className='popup-button-wrapper'>
                            <BtnSubmit text='הבנתי, תודה' onclick={handleChangeCodeFinishClick} />
                        </div>
                    </div>
                )
        }
    }

    function handleCode(value) {
        setNewCode(value);
    }

    async function handleChangeCodeClick() {
        const isValidate = isNumeric(newCode) && (newCode.length == 4);
        if (!isValidate) {
            setCodeValidationError('אנא וודאו שהשלמתם את כל השדות');
            return;
        }

        parentalControlReport('New Parental Code Page', 'Ongoing', 'New Parental Code Page Button Clicked', props.account?.username, props.userData?.firstName + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '', props.contactNumber, props.tvAccount?.currentParrentalCodeAccount?.ban);

        let req = {externalAssetId: props.account?.assetExternalId, pinCode: newCode}
        const res = await props.doResetParentalCode(req);
        const isSuccess = res?.payload;

        if(isSuccess) {
            setChangeCodePopupStatus('success');
            parentalControlReport('New Parental Code Page', 'Completed', 'Success', props.account?.username, props.userData?.firstName + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '', props.contactNumber, props.tvAccount?.currentParrentalCodeAccount?.ban);
        }
        else {
            setChangeCodePopupStatus('error');
            parentalControlReport('New Parental Code Page', 'Error', 'General Error', props.account?.username, props.userData?.firstName + ' ' + props.userData?.lastName, props.userData?.IDNumber, '', '', props.contactNumber, props.tvAccount?.currentParrentalCodeAccount?.ban);
        }

        setCode(newCode);
        setInputType('password');
    }

    function handleChangeCodeFinishClick() {
        setIsDisplayChangeCodePopup(false);
    }

    function isNumeric(str) {
        return str.match(/^\d+$/) !== null;
    }

};

const mapStateToProps = (state) => {
    return {
        tvAccount: state.TvActivationCodeRecovery,
        pinParentalCode: state.TvActivationCodeRecovery?.pinParentalCode,
        TvActivationCodeRecovery: state.TvActivationCodeRecovery,
        contactNumber: state.authentication?.loginData?.userDetails?.contactNumber,
        account: state.TvActivationCodeRecovery?.currentParrentalCodeAccount,
        ban: state.TvActivationCodeRecovery?.selectedCustomer?.ban
    };
};

const mapDispatchToProps = {
    doResetParentalCode,
    setParentalCodeStep,
    saveToHistory,
    toggleDisplayPopUp,
    getPinParentalCodeAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetCode);
